import { Box, Typography } from "@mui/material";
import React from "react";
import HeroSection from "src/theme/HeroSection";

const OriginStory: React.FC = () => {
    return (
        <Box sx={{ mb: 8 }}>
            <HeroSection
                imageUrl="/images/SeanValentine-HGP.jpg"
                minHeight="55vh"
            >
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        px: { xs: 3, sm: 4, md: 6 },
                        py: 4,
                        maxWidth: 560
                    }}
                >
                    <Typography
                        variant="h3"
                        component="h1"
                        sx={{
                            mb: 3,
                            fontWeight: "bold",
                            color: "white"
                        }}
                    >
                        About Strong Mind Strong Performance
                    </Typography>

                    <Typography
                        component="p"
                        sx={{
                            lineHeight: 1.6,
                            mb: 2,
                            color: "rgba(255,255,255,0.95)"
                        }}
                    >
                        Founded by a guardian of two teenage athletes and with over 10 years of youth development experience.
                        Strong Mind Strong Performance was created to help guardians and coaches connect with young athletes—going
                        beyond skill and strength into self-belief, emotional regulation, and mental resilience.
                    </Typography>

                    <Typography
                        component="p"
                        sx={{
                            lineHeight: 1.6,
                            color: "rgba(255,255,255,0.95)"
                        }}
                    >
                        We know that sports success is 90% psychological, and we're here to train that side too.
                    </Typography>
                </Box>
            </HeroSection>
        </Box>
    );
};

export default OriginStory;
